import {Directory} from '../../components/Directory/Directory'

export const Home =()=>{

    return (
        <>
            <Directory />
        </>
    )
}